import React from 'react';
import { InformationIcon, Row, HeadingText } from '@paypalcorp/pp-react';

import PropTypes from 'prop-types';
import styles from './EnvSetUp.module.less';

function EnvSetUp({ devEnv, title }) {
  return (
    <div>
      {title && (
        <Row className={`${styles.dev_env_title}`}>
          <HeadingText size="lg" type="medium">
            {title}
          </HeadingText>
        </Row>
      )}
      {devEnv.map(({ badgeNumber, content, codeBlock, additionalContent, infoBox }, index) => (
        <Row key={index}>
          {badgeNumber && content && (
            <Row className={styles.dev_env_content_box}>
              <div className={styles.dev_env_custom_badge}>
                <p className={styles.dev_env_custom_badge_text}>{badgeNumber}</p>
              </div>
              <div
                className={styles.dev_env_content}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </Row>
          )}
          {codeBlock && (
            <Row className={`${styles.dev_env_content_box}`}>
              <div
                className={`${styles.dev_env_code_block} ${styles.dev_env_content}`}
                dangerouslySetInnerHTML={{ __html: codeBlock }}
              />
            </Row>
          )}
          {additionalContent && (
            <Row className={`${styles.dev_env_content_box}`}>
              <div
                className={`${styles.dev_env_content}`}
                dangerouslySetInnerHTML={{ __html: additionalContent }}
              />
            </Row>
          )}
          {infoBox && (
            <div className={`${styles.info_box}`}>
              <InformationIcon />
              <div
                className={`${styles.info_box_text} ${styles.dev_env_content}`}
                dangerouslySetInnerHTML={{ __html: infoBox }}
              />
            </div>
          )}
        </Row>
      ))}
    </div>
  );
}

EnvSetUp.propTypes = {
  devEnv: PropTypes.object.isRequired,
  title: PropTypes.string
};

export default EnvSetUp;
